import React from 'react'
import PropTypes from 'prop-types'

import './ButtonClose.scss'

const ButtonClose = ({ onClick, visible }) => {
  return (
    <article className={visible ? 'ou_static-button-close-in' : 'ou_static-button-close-out'}>
      <span className={'ou_static-button-close '} onClick={onClick} />
    </article>
  )
}

ButtonClose.propTypes = {
  onClick: PropTypes.func,
  visible: PropTypes.bool
}

export default ButtonClose



// WEBPACK FOOTER //
// ./src/templates/outSide/components/buttonClose/ButtonClose.js